/**
 * Replace the last path segment, tolerating a trailing slash.
 *
 * Example Input:
 * pathname="/straps/leather/566X.A/", nextSegment="566XS.A"
 *
 * Example Output:
 * "/straps/leather/566XS.A/"
 */
export function replaceLastPathSegment(pathname: string, nextSegment: string): string {
  const parts = pathname.split('/');
  const lastIdx = parts.at(-1) === '' ? parts.length - 2 : parts.length - 1;
  if (lastIdx < 0) return `/${nextSegment}`;
  parts[lastIdx] = nextSegment;
  return parts.join('/');
}
